import { useThemeStore } from "@stores/theme.store";
import moment from "moment";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const StudentEyeHealthDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Kesehatan Mata",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Kesehatan Mata", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal</div>
        <div className="color-theme mb-3">
          {moment(state.tanggal ?? Date.now()).format(
            "dddd, DD MMMM YYYY | HH:mm"
          )}
        </div>
        <div className="color-highlight">Petugas</div>
        <div className="color-theme mb-3">{state.petugas ?? "-"}</div>
        <div className="color-highlight">Mata Kanan</div>
        <div className="color-theme mb-3">{state.mata_kanan ?? "-"}</div>
        <div className="color-highlight">Nilai Mata Kanan</div>
        <div className="color-theme mb-3">{state.nilai_mata_kanan ?? "-"}</div>
        <div className="color-highlight">Mata Kiri</div>
        <div className="color-theme mb-3">{state.mata_kiri ?? "-"}</div>
        <div className="color-highlight">Nilai Mata Kiri</div>
        <div className="color-theme mb-3">{state.nilai_mata_kiri ?? "-"}</div>
      </div>
    </div>
  );
};
